import { CrossIcon, EditIcon, SaveIcon } from '../../../utils/SVGIcon';
import { useProfileInfo } from '../UserProfileProvider';

function ActionButton({ isEditMode, saveClick, editClick, cancelEditClick }) {
    if (isEditMode) {
        return (
            <div className="flex justify-center items-center gap-1.5">
                <button
                    type="button"
                    onClick={saveClick}
                    className="flex justify-center items-center   h-7 w-7 md:h-8 md:w-8 p-2 bg-primary-100 rounded-full"
                >
                    <SaveIcon />
                </button>
                <button
                    type="button"
                    onClick={cancelEditClick}
                    className="flex justify-center items-center   h-7 w-7 md:h-8 md:w-8 p-2 bg-primary-100 text-[#506B76] rounded-full"
                >
                    <CrossIcon />
                </button>
            </div>
        );
    }
    return (
        <button
            type="button"
            onClick={editClick}
            className="flex justify-center items-center   h-7 w-7 md:h-8 md:w-8 p-2 bg-primary-100 rounded-full"
        >
            <EditIcon />
        </button>
    );
}

function UserInfoCard({ title, name, value = '', saveClick, customAction }) {
    const { propertyName, handleEditClick, handleReset, formData, handleChange } = useProfileInfo();

    // --Check if the input is in edit mode
    const isEditMode = propertyName?.length && propertyName === name;

    // --Get the input value
    const inputValue = isEditMode ? formData[name] : value;

    // Move the cursor to the right
    const inputElement = document.getElementById('myInput');
    inputElement?.setSelectionRange(inputElement.value.length, inputElement.value.length);

    return (
        <div className="flex justify-between items-center w-full p-2 md:p-3 rounded-10 bg-primary-50 overflow-hidden box-border">
            <div className="w-10/12">
                <h3 className="text-primary-700 text-sm md:text-base font-normal">
                    {title || '--'}
                </h3>
                <input
                    id="myInput"
                    type="text"
                    name={name}
                    value={inputValue || ''}
                    onChange={handleChange}
                    ref={(inp) => (isEditMode ? inp?.focus() : null)}
                    readOnly={!isEditMode}
                    className="w-full outline-none text-primary text-base md:text-xl font-medium bg-transparent py-1 px-2 rounded-md relative -left-2"
                />
            </div>
            <div className={propertyName?.length && propertyName !== name ? 'hidden' : 'block'}>
                {customAction || (
                    <ActionButton
                        isEditMode={isEditMode}
                        saveClick={saveClick}
                        editClick={() => handleEditClick(name, value)}
                        cancelEditClick={handleReset}
                    />
                )}
            </div>
        </div>
    );
}

export default UserInfoCard;
